// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.form_slider {
  height: 100%;
}
.form_slider form {
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  max-width: 100%;
  padding: 0px;
}
.form_slider form .form_slide {
  position: absolute;
  padding: 15px;
  display: flex;
  height: 100%;
  width: 100%;
  transition: all 400ms;
  overflow: hidden;
}
.form_slider form .form_slide .form_slide_content {
  display: none;
  height: calc(100% - 60px);
  flex: 1 1;
  width: 100%;
  overflow-y: scroll;
}
.form_slider form .form_slide .form_slide_content .scrollX {
  padding: 10px 0px;
}
.form_slider form .form_slide .form_slide_content .scrollX input {
  min-width: 150px;
}
.form_slider form .form_slide .form_slide_content .scrollX select {
  min-width: 120px;
}
.form_slider form .form_slide .form_group {
  margin: 40px 0px;
}
.form_slider.slide-1 .form_slide:nth-child(1) {
  transform: translateX(0);
}
.form_slider.slide-1 .form_slide:nth-child(1) .form_slide_content {
  display: block;
}
.form_slider.slide-1 .form_slide:nth-child(2) {
  transform: translateX(100%);
}
.form_slider.slide-1 .form_slide:nth-child(3) {
  transform: translateX(200%);
}
.form_slider.slide-1 .form_slide:nth-child(4) {
  transform: translateX(300%);
}
.form_slider.slide-1 .form_slide:nth-child(5) {
  transform: translateX(400%);
}
.form_slider.slide-2 .form_slide:nth-child(1) {
  transform: translateX(-100%);
}
.form_slider.slide-2 .form_slide:nth-child(2) {
  transform: translateX(0);
}
.form_slider.slide-2 .form_slide:nth-child(2) .form_slide_content {
  display: block;
}
.form_slider.slide-2 .form_slide:nth-child(3) {
  transform: translateX(100%);
}
.form_slider.slide-2 .form_slide:nth-child(4) {
  transform: translateX(200%);
}
.form_slider.slide-2 .form_slide:nth-child(5) {
  transform: translateX(300%);
}
.form_slider.slide-3 .form_slide:nth-child(1) {
  transform: translateX(-200%);
}
.form_slider.slide-3 .form_slide:nth-child(2) {
  transform: translateX(-100%);
}
.form_slider.slide-3 .form_slide:nth-child(3) {
  transform: translateX(0);
}
.form_slider.slide-3 .form_slide:nth-child(3) .form_slide_content {
  display: block;
}
.form_slider.slide-3 .form_slide:nth-child(4) {
  transform: translateX(100%);
}
.form_slider.slide-3 .form_slide:nth-child(5) {
  transform: translateX(200%);
}
.form_slider.slide-4 .form_slide:nth-child(1) {
  transform: translateX(-300%);
}
.form_slider.slide-4 .form_slide:nth-child(2) {
  transform: translateX(-200%);
}
.form_slider.slide-4 .form_slide:nth-child(3) {
  transform: translateX(-100%);
}
.form_slider.slide-4 .form_slide:nth-child(4) {
  transform: translateX(0);
}
.form_slider.slide-4 .form_slide:nth-child(4) .form_slide_content {
  display: block;
}
.form_slider.slide-4 .form_slide:nth-child(5) {
  transform: translateX(100%);
}
.form_slider.slide-5 .form_slide:nth-child(1) {
  transform: translateX(-400%);
}
.form_slider.slide-5 .form_slide:nth-child(2) {
  transform: translateX(-300%);
}
.form_slider.slide-5 .form_slide:nth-child(3) {
  transform: translateX(-200%);
}
.form_slider.slide-5 .form_slide:nth-child(4) {
  transform: translateX(-100%);
}
.form_slider.slide-5 .form_slide:nth-child(5) {
  transform: translateX(0);
}
.form_slider.slide-5 .form_slide:nth-child(5) .form_slide_content {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/misc/form-slider/_formSlider.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC9HA;EACI,YAAA;AAkEJ;AAhEI;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAkER;AAhEQ;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACI,gBAAA;AAkEhB;AAhEY;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAkEhB;AAhEY;EACI,iBAAA;AAkEhB;AAjEgB;EACI,gBAAA;AAmEpB;AAjEgB;EACI,gBAAA;AAmEpB;AA7DY;EACI,gBAAA;AA+DhB;AAxDY;EACI,wBAAA;AA0DhB;AAzDgB;EACI,cAAA;AA2DpB;AAxDY;EACI,2BAAA;AA0DhB;AAxDY;EACI,2BAAA;AA0DhB;AAxDY;EACI,2BAAA;AA0DhB;AAxDY;EACI,2BAAA;AA0DhB;AAnDY;EACI,4BAAA;AAqDhB;AAnDY;EACI,wBAAA;AAqDhB;AApDgB;EACI,cAAA;AAsDpB;AAnDY;EACI,2BAAA;AAqDhB;AAnDY;EACI,2BAAA;AAqDhB;AAnDY;EACI,2BAAA;AAqDhB;AA9CY;EACI,4BAAA;AAgDhB;AA9CY;EACI,4BAAA;AAgDhB;AA9CY;EACI,wBAAA;AAgDhB;AA/CgB;EACI,cAAA;AAiDpB;AA9CY;EACI,2BAAA;AAgDhB;AA9CY;EACI,2BAAA;AAgDhB;AAzCY;EACI,4BAAA;AA2ChB;AAzCY;EACI,4BAAA;AA2ChB;AAzCY;EACI,4BAAA;AA2ChB;AAzCY;EACI,wBAAA;AA2ChB;AA1CgB;EACI,cAAA;AA4CpB;AAzCY;EACI,2BAAA;AA2ChB;AApCY;EACI,4BAAA;AAsChB;AApCY;EACI,4BAAA;AAsChB;AApCY;EACI,4BAAA;AAsChB;AApCY;EACI,4BAAA;AAsChB;AApCY;EACI,wBAAA;AAsChB;AArCgB;EACI,cAAA;AAuCpB","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../../styles/variables\";\r\n\r\n.form_slider {\r\n    height: 100%;\r\n\r\n    form {\r\n        position: relative;\r\n        overflow: hidden;\r\n        height: 100%;\r\n        width: 100%;\r\n        max-width: 100%;\r\n        padding: 0px;\r\n\r\n        .form_slide {\r\n            position: absolute;\r\n            padding: 15px;\r\n            display: flex;\r\n            height: 100%;\r\n            width: 100%;\r\n            transition: all $animation_speed;\r\n                overflow: hidden;\r\n\r\n            .form_slide_content {\r\n                display: none;\r\n                height: calc(100% - 60px);\r\n                flex: 1;\r\n                width: 100%;\r\n                overflow-y: scroll;\r\n\r\n            .scrollX {\r\n                padding: 10px 0px;\r\n                input {\r\n                    min-width: 150px;\r\n                }\r\n                select {\r\n                    min-width: 120px;\r\n                }\r\n            }\r\n            }\r\n\r\n\r\n            .form_group {\r\n                margin: 40px 0px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.slide-1 {\r\n        .form_slide {\r\n            &:nth-child(1) {\r\n                transform: translateX(0);\r\n                .form_slide_content {\r\n                    display: block;\r\n                }\r\n            }\r\n            &:nth-child(2) {\r\n                transform: translateX(100%);\r\n            }\r\n            &:nth-child(3) {\r\n                transform: translateX(200%);\r\n            }\r\n            &:nth-child(4) {\r\n                transform: translateX(300%);\r\n            }\r\n            &:nth-child(5) {\r\n                transform: translateX(400%);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.slide-2 {\r\n        .form_slide {\r\n            &:nth-child(1) {\r\n                transform: translateX(-100%);\r\n            }\r\n            &:nth-child(2) {\r\n                transform: translateX(0);\r\n                .form_slide_content {\r\n                    display: block;\r\n                }\r\n            }\r\n            &:nth-child(3) {\r\n                transform: translateX(100%);\r\n            }\r\n            &:nth-child(4) {\r\n                transform: translateX(200%);\r\n            }\r\n            &:nth-child(5) {\r\n                transform: translateX(300%);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.slide-3 {\r\n        .form_slide {\r\n            &:nth-child(1) {\r\n                transform: translateX(-200%);\r\n            }\r\n            &:nth-child(2) {\r\n                transform: translateX(-100%);\r\n            }\r\n            &:nth-child(3) {\r\n                transform: translateX(0);\r\n                .form_slide_content {\r\n                    display: block;\r\n                }\r\n            }\r\n            &:nth-child(4) {\r\n                transform: translateX(100%);\r\n            }\r\n            &:nth-child(5) {\r\n                transform: translateX(200%);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.slide-4 {\r\n        .form_slide {\r\n            &:nth-child(1) {\r\n                transform: translateX(-300%);\r\n            }\r\n            &:nth-child(2) {\r\n                transform: translateX(-200%);\r\n            }\r\n            &:nth-child(3) {\r\n                transform: translateX(-100%);\r\n            }\r\n            &:nth-child(4) {\r\n                transform: translateX(0);\r\n                .form_slide_content {\r\n                    display: block;\r\n                }\r\n            }\r\n            &:nth-child(5) {\r\n                transform: translateX(100%);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.slide-5 {\r\n        .form_slide {\r\n            &:nth-child(1) {\r\n                transform: translateX(-400%);\r\n            }\r\n            &:nth-child(2) {\r\n                transform: translateX(-300%);\r\n            }\r\n            &:nth-child(3) {\r\n                transform: translateX(-200%);\r\n            }\r\n            &:nth-child(4) {\r\n                transform: translateX(-100%);\r\n            }\r\n            &:nth-child(5) {\r\n                transform: translateX(0);\r\n                .form_slide_content {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
